<template>
  <div class="baxia-join-page">
    <!-- 顶部banner -->
    <img class="banner-img" src="/static/images/bx/banner.png">
    
    <!-- Join页面内容 -->
    <div class="join-content">
      <!-- 验证结果文字 -->
      <div class="verification-text">
        查询的「春·复苏」产品为正品，请放心使用！
      </div>
      
      <!-- 商店图片 -->
      <img v-if="showActivity" class="shop-img" :src="isPointsClaimed ? '/static/images/bx/ok.png' : '/static/images/bx/shop.png'">
      
      <!-- 积分提示 -->
      <div v-if="showActivity" class="points-text">
        {{ isPointsClaimed ? '积分已被领取' : '恭喜获得' + points + '积分' }}
      </div>
      
      <!-- 商品信息框 -->
      <div class="product-info-card">
        <div class="info-row">
          <span class="info-label">商品名称：</span>
          <span class="info-value">{{productName}}</span>
        </div>
        <div class="info-row">
          <span class="info-label">商品编号：</span>
          <span class="info-value">{{productNo }}</span>
        </div>
      </div>
      
      <!-- 领取图片 -->
      <wx-open-launch-weapp 
        v-if="showActivity"
        id="launch-btn" 
        class="lingqu-img"
        :appid="miniAppId" 
        :username="miniAppOriginalId" 
        :path="miniAppPage"> 
        <script type="text/wxtag-template"> 
          <img src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/qwsc-0f2b6bc69f9b40369558d9980a85c31e.png" 
            style="width: 100%;height: auto;display: block;" /> 
        </script> 
      </wx-open-launch-weapp>
      
      <!-- 内容区域 -->
      <div class="content-area">
        <!-- Join页面内容 -->
      </div>
    </div>
  </div>
</template>

<style scoped>
.baxia-join-page {
  width: 100vw;
  min-height: 100vh;
  background-color: rgb(246, 246, 246);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
}

.banner-img {
  width: 100vw;
  height: auto;
  margin-top: 0;
}

.join-content {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 3vh;
}

.verification-text {
  margin-top: 1.6vh;
  width: 80vw;
  text-align: center;
  font-size: 3.5vw;
  color: #333;
}

.shop-img {
  margin-top: 2.5vh;
  width: 25vw;
  height: auto;
}

.points-text {
  margin-top: 2vh;
  font-size: 5.5vw;
  color: black;
  font-weight: bold;
}

.product-info-card {
  margin-top: 2.5vh;
  width: 80vw;
  background-color: white;
  border-radius: 2vw;
  padding: 1vw 2vw;
}

.info-row {
  display: flex;
  margin: 1.2vh 0;
}

.info-label {
  font-size: 3.5vw;
  color: #333;
  flex: 0 0 20vw;
  margin-left: 2vw;
}

.info-value {
  font-size: 3.5vw;
  color: #666;
  flex: 1;
}

.lingqu-img {
  margin-top: 3vh;
  width: 45vw;
  height: auto;
}

/* 小屏幕设备适配 (iPhone 5/SE等) */
@media screen and (max-height: 667px) {
  .verification-text {
    font-size: 3vw;
  }
  
  .shop-img {
    width: 20vw;
  }
  
  .points-text {
    font-size: 4.5vw;
  }
  
  .product-info-card {
    padding: 1.2vw 2.5vw;
  }
  
  .info-label, .info-value {
    font-size: 3vw;
  }
  
  .lingqu-img {
    width: 40vw;
  }
}

.content-area {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
<script>
import { getJSSDK, getScoreConfig, getTemplate, registerByOpenId, joinActivity, getInfoByCode } from '../../api/api'
import wx from 'weixin-js-sdk'

export default {
  name: 'BaXiaJoin',
  data() {
    return {
      appId: process.env.ENV_NUM === '1' ? 'wx1e7875f5abb1fa0a' : 'wxbc22565b3e7a59fd',
      eno: process.env.ENV_NUM === '1' ? '138823261350' : '138482046494',
      code: '',
      deptId: '',
      wyAuthCode: '',
      activityId: '',
      activityRule: '',
      shopUrl: '',
      miniAppId: '',
      miniAppOriginalId: '',
      miniAppPage: '',
      showActivity: false,
      token: '',
      points: '',
      showPoints: false,
      isPointsClaimed: false,
      productNo: '',
      productName: ''
    }
  },
  methods: {
    getCodeInfo() {
      getInfoByCode(this.code).then(res => {
        if (res.data && res.data.code === "200" && res.data.data) {
          if (res.data.data.productNo) {
            this.productNo = res.data.data.productNo
          }
          if (res.data.data.productName) {
            this.productName = res.data.data.productName
          }
        }
      }).catch(err => {
        console.error('获取码相关信息失败:', err)
      })
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ]
        })
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          })
        })
      })
    },
    async getScoreConfig() {
      getScoreConfig(this.deptId).then(res => {
        if (res.data && res.data.data) {
          this.shopUrl = res.data.data.shopUrl
          const data = this.shopUrl.split('|')
          this.miniAppId = data[0]
          this.miniAppOriginalId = data[1]
          this.miniAppPage = data[2]
        }
      })
    },
    async getTemplate() {
      getTemplate(this.deptId).then(res => {
        if (res.data && res.data.data) {
          this.activityId = res.data.data.activityId
          this.activityRule = res.data.data.activityRule
          if (!this.activityId) {
            alert('活动已下线，请关注后续最新活动')
          } else {
            this.registerUser()
          }
        } else {
          alert('活动已下线，请关注后续最新活动')
        }
      })
    },
    registerUser() {
      registerByOpenId(this.eno, this.wyAuthCode).then(res => {
        if (res.data && res.data.code !== "200") {
          alert(res.data.message || '注册失败')
          this.showActivity = false
        } else if (res.data && res.data.data) {
          this.token = res.data.data.token
          this.joinActivity()
        }
      }).catch(err => {
        console.error('注册用户失败:', err)
      })
    },
    async joinActivity() {
      try {
        const data = {
          code: this.code,
          activityId: this.activityId,
          authCode: this.wyAuthCode,
          userToken: this.token
        }
        const result = await joinActivity(data)
        if (result.data.code === "200") {
          this.showActivity = true
          this.points = result.data.data.giftValue
        } else if (result.data.code === "500001") {
          this.showActivity = true
          this.isPointsClaimed = true
        } else {
          alert(result.data.message || '参与活动失败，请联系客服处理')
        }
      } catch (error) {
        console.error('参与活动失败:', error)
        alert("参与活动失败，请联系客服处理")
      }
    }
  },
  async mounted() {
    // 从路由参数中获取参数
    if (this.$route.query.eno) {
      this.eno = this.$route.query.eno
    }
    if (this.$route.query.c) {
      this.code = this.$route.query.c
    }
    if (this.$route.query.deptId) {
      this.deptId = this.$route.query.deptId
    }
    if (this.$route.query.wyAuthCode) {
      this.wyAuthCode = this.$route.query.wyAuthCode
    }
    // 获取码相关信息
    this.getCodeInfo()
    // 获取微信JSSDK配置
    this.getWxJs()
    // 获取积分配置和模板
    await this.getScoreConfig()
    await this.getTemplate()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/BaXia/Join.vue